class FetchBeneficiary {
	constructor(
		public readonly facilityId: number,
		public readonly beneficiaryId: number,
	) {
		Object.freeze(this);
	}
}

export default FetchBeneficiary;
